import type { FixedTermMarket } from '@/utils/internalAppSdk'

const getRelevance = (candidate: FixedTermMarket, market: FixedTermMarket) => {
  if (candidate.underlyingAsset.assetCaip === market.underlyingAsset.assetCaip) return 3
  if (candidate.accountingAsset.assetCaip === market.accountingAsset.assetCaip) return 2
  if (candidate.underlyingProtocol.name.toLowerCase() === market.underlyingProtocol.name.toLowerCase()) return 1
  return 0
}

export const getRelatedFixedTermMarkets = (markets: FixedTermMarket[], market: FixedTermMarket, limit: number) =>
  markets
    .filter((candidate) => candidate.network.name !== market.network.name || candidate.vaultId !== market.vaultId)
    .map((candidate) => ({ candidate, relevance: getRelevance(candidate, market) }))
    .sort(
      (a, b) =>
        b.relevance - a.relevance ||
        Math.abs(a.candidate.expiry - market.expiry) - Math.abs(b.candidate.expiry - market.expiry) ||
        Number(b.candidate.tvl.usd) - Number(a.candidate.tvl.usd)
    )
    .slice(0, limit)
    .map(({ candidate }) => candidate)
